// Figma: same addon row style as CheckboxField, with EV icon
// Replaces the old FieldWrapper + custom checkbox implementation

import CheckboxField from '~/components/fields/CheckboxField'

function EvIcon() {
  return (
    <div className="size-11 flex items-center justify-center shrink-0">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M19.9814 3C20.5439 3.00017 20.9998 3.4561 21 4.01855V12C21 16.9706 16.9706 21 12 21C10.1309 21 8.39479 20.4304 6.95605 19.4551C6.7282 19.3006 6.61411 19.2231 6.51074 19.2041C6.4144 19.1865 6.33056 19.1949 6.23926 19.2305C6.14145 19.2686 6.05164 19.3575 5.87305 19.5361L4.81055 20.5986C4.64615 20.763 4.56403 20.8461 4.47852 20.8955C4.24656 21.0293 3.96046 21.0293 3.72852 20.8955C3.643 20.8461 3.56088 20.763 3.39648 20.5986C3.23222 20.4344 3.14994 20.3521 3.10059 20.2666C2.96674 20.0346 2.96666 19.7486 3.10059 19.5166C3.14998 19.4312 3.23229 19.3488 3.39648 19.1846L4.45996 18.1211C4.63844 17.9426 4.72845 17.8536 4.7666 17.7559C4.80212 17.6646 4.80955 17.5807 4.79199 17.4844C4.77309 17.3811 4.69615 17.2668 4.54199 17.0391C3.56868 15.6013 3 13.867 3 12C3 7.02944 7.02944 3 12 3H19.9814ZM12.9502 11.0498C12.5597 10.6593 11.9257 10.6593 11.5352 11.0498L7.29297 15.293C6.90244 15.6835 6.90244 16.3165 7.29297 16.707C7.68349 17.0976 8.31651 17.0976 8.70703 16.707L12.9502 12.4648C13.3407 12.0743 13.3407 11.4403 12.9502 11.0498Z" fill="#2B913B" />
      </svg>
    </div>
  )
}

export default function ElectricCarCheckbox(props) {
  return <CheckboxField {...props} iconNode={<EvIcon />} />
}
